Vue.asyncComponent('ak-filters', {
    emptyState: {
        selectedFilter: '',
        filter: {
            values: []
        }
    },
    props: {
        filters: {
            type: Object,
            required: false,
            default: () => {}
        },
        activeFilter: {
            type: Object,
            required: false,
            default: null
        },
        value: {
            type: Boolean,
            required: true,
            default: false
        },
    },
    data() {
        return {
            selectedFilter: '',
            filter: {
                values: []
            }
        }
    },
    computed: {
        filterNames() {
            if (this.filters.filters) return this.filters.filters.map(x => x.title);
            else return [];
        },
        getFilterWidgets() {
            let widgets = [];
            if (this.selectedFilter !== '') widgets = this.filters.filters.find(x => x.title === this.selectedFilter).steps;

            // set the active filter values
            for (const key in this.filter.values) {
                widgets.find(widget => widget.index == key).widget.formControl.value = this.filter.values[key];
            }

            return widgets;
        },
        show: {
            get () {
                return this.value;
            },
            set (value) {
                this.$emit('close');
            }
        },
    },
    methods: {
        confirmDialog() {
            if (!this.selectedFilter) return;

            const filter = this.filters.filters.find(x => x.title === this.selectedFilter);

            this.$emit('filterAdded', {
                ...filter,
                values: [ ...this.filter.values ]
            });
        },
        cancelDialog() {
            Object.assign(this.$data, this.emptyState);
            this.$emit('close');
        },
        handleWidgetInput(e, i) {
            this.filter.values[i] = e;
        }
    },
    watch: {
        value() {
            this.dialogVisible = this.showDialog;
            if (!this.showDialog) Object.assign(this.$data, this.emptyState);
            this.filter.values = [];
        }
    },
    mounted() {
        if (this.activeFilter !== null) {
            this.selectedFilter = this.filters.filters.find(x => x.id === this.activeFilter.id).title;
            this.filter.values = [ ...this.activeFilter.values ];

            // when the value is a number we parse it to an int
            if ( ! isNaN(this.activeFilter.values[1])) {
                this.filter.values[1] = parseInt(this.activeFilter.values[1]);
            }
        } else if (this.filters.filters.length === 1) {
            this.selectedFilter = this.filters.filters[0].title;
        }
    }
}, 'grid/ak-filters.html');